import Layout from "../layouts/LayoutDefault.jsx";
import MainContainer from "../components/MainContainer";
import ContentContainer from "../components/ContentContainer";
import Image404 from "../assets/404.png";

const pageNotFound = () => {
  return (
    <>
      <Layout
        title="404 - Kunde inte hitta det, Ledsen"
        description="Ledsen att vi inte kunde hitta något annat än den här 404-sidan åt dig."
      >
        <MainContainer>
          <ContentContainer>
            <div className="flex flex-col items-center text-center space-y-4 max-w-md mx-auto my-16">
              <div className="w-[180px] mb-4">
                <img
                  src={Image404}
                  alt="ett tomt cdfodral"
                  className="filter grayscale brightness-75"
                />
              </div>
              <h1 className="text-8xl font-black text-white uppercase tracking-widest leading-none">
                404
              </h1>
              <p className="text-stone-400 text-sm leading-relaxed">
                Vi sökte genom arkiven men hittade inte det du sökte, ledsen för
                det. Kanske finns inte sidan eller så har du inte rätt behörighet.
              </p>
              <a className="block pt-4" href="/">
                <button className="btn bg-[#0047ff] hover:bg-blue-700 text-white border-none rounded-full btn-wide font-bold uppercase tracking-wider text-xs shadow-[0_4px_15px_rgba(0,71,255,0.3)] transition-transform duration-300 hover:scale-[1.02]">
                  Startsidan
                </button>
              </a>
            </div>
          </ContentContainer>
        </MainContainer>
      </Layout>
    </>
  );
};

export default pageNotFound;
